/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Organizeravataradd2Inputs */

const en_organizeravataradd2 = /** @type {(inputs: Organizeravataradd2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add a picture`)
};

const de_organizeravataradd2 = /** @type {(inputs: Organizeravataradd2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profilbild hinzufügen`)
};

/**
* | output |
* | --- |
* | "Add a picture" |
*
* @param {Organizeravataradd2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const organizeravataradd2 = /** @type {((inputs?: Organizeravataradd2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Organizeravataradd2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_organizeravataradd2(inputs)
	return de_organizeravataradd2(inputs)
});
export { organizeravataradd2 as "organizerAvatarAdd" }